
const modal: HTMLElement = document.querySelector('.webshop-product-preview-modal');
const buttons: NodeList = document.querySelectorAll('.js-togglePDFModal');

buttons.forEach(item => {
  item.addEventListener('click', () => {
    if ( modal.hasAttribute('data-modal-open') ) {
      closeModal();
    } else {
      openModal();
    }
  });
});

function openModal(): void {
  disableScroll();
  modal.setAttribute('data-modal-open', 'true');
  setTimeout(() => {
    modal.style.opacity = '1';
  }, 300);
}

function closeModal(): void {
  modal.style.opacity = '0';
  setTimeout(() => {
    modal.removeAttribute('data-modal-open');
    enableScroll();
  }, 300);
}


function disableScroll(): void {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  window.onscroll = function(): void {
    window.scrollTo(scrollLeft, scrollTop);
  };
}

function enableScroll(): void {
  window.onscroll = function(): void {
    return undefined;
  };
}
